import { AxiosError } from 'axios';
import { QUERY_KEYS } from 'constants/query-keys';
import { useQuery } from 'react-query';
import { getCourseData } from 'services/elearning';
import { Course } from 'types/elearning';
import { queryKeyWithLanguage } from 'utils/language';

// ID of the legacy hand-hygiene course that uses the old layout
export const LEGACY_COURSE_ID = 1;

export const useCourses = () => {
    const { data, isLoading } = useQuery<Course[], AxiosError>(
        queryKeyWithLanguage(QUERY_KEYS.ALL_COURSES),
        () => getCourseData(),
        { staleTime: Infinity }
    );

    return {
        allCoursesData: data ?? [],
        isLoadingCourses: isLoading,
    };
};
